import { ApiType } from "@gymflow/common";
import { DetailedInvoiceDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { memberQueryKeys } from "./memberQueryKeys";

export function useQueryInvoice(
  {
    api,
    invoiceNumber,
  }: {
    api: ApiType;
    invoiceNumber: string;
  },
  opts?: Omit<UseQueryOptions<DetailedInvoiceDTO>, "queryKey">,
) {
  return useQuery({
    queryKey: memberQueryKeys.invoice(invoiceNumber),
    queryFn: async () => {
      return (await api.memberApi.getInvoiceByInvoiceNumber(invoiceNumber))
        .data;
    },
    ...opts,
  });
}
